import { render, staticRenderFns } from "./SectionSubtitle.vue?vue&type=template&id=4ab32de2&scoped=true&"
import script from "./SectionSubtitle.vue?vue&type=script&lang=ts&"
export * from "./SectionSubtitle.vue?vue&type=script&lang=ts&"
import style0 from "./SectionSubtitle.vue?vue&type=style&index=0&id=4ab32de2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab32de2",
  null
  
)

export default component.exports